export default __webpack_public_path__ + "img/check-white.04cafb35.svg";